<template>
  <div>
    <div class="container text-align--center my-4 my-md-5">
      <h2 class="mb-1 mb-md-3">Kiitos.</h2>
      <div class="intro mb-5">
        Valintanne on lähetty jälleenmyyjällenne.
      </div>

      <button
        type="button"
        class="btn btn-t1-secondary"
        @click="printElem('printable')"
      >
        <i
          class="fa fa-fw fa-print"
          aria-hidden="true"
        ></i> Tulosta yhteenveto
      </button>
      <button
        type="button"
        class="btn btn-t1-secondary"
        @click="$router.push('/'+$route.params.car+'/palaute')"
      >
        <i
          class="fa fa-fw fa-comment-o"
          aria-hidden="true"
        ></i> Anna palautetta
      </button>
    </div>
    <div class="mt-3">
      <form-head :disabled="true"></form-head>
      <p class="support-text mb-2 mb-md-4">Huomaathan, että valintojesi täyttämisen nopeuttamiseksi olemme jo esitäyttäneet oletusvalinnat, jotka voit jättää valituiksi tai vaihtaa haluamaksesi.</p>
      <h2 class="mb-1 mb-md-3">Yhteenveto autoni asetuksista</h2>
      <summary-list
        :data="data"
        id="printable"
      ></summary-list>
    </div>
    <div class="my-4"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FormHead from "../components/FormHead";
import CarHeading from "../components/CarHeading";
const SummaryList = () =>
  import(/* webpackChunkName: "summarylist" */ "../components/SummaryList");
export default {
  computed: {
    ...mapGetters({
      getTemplateById: "getTemplateById",
      getForm: "getForm",
      getDefaults: "getDefaults",
      getCarByKey: "getCarByKey"
    }),
    car() {
      return this.getCarByKey(this.$route.params.car);
    },
    template() {
      return this.getTemplateById(this.car.template_id);
    },
    data() {
      if (this.template) {
        let data = JSON.parse(this.template.data);
        return data;
      }
      return 0;
    }
  },
  methods: {
    printElem(divId) {
      var content = document.getElementById(divId).innerHTML;
      var mywindow = window.open(
        "",
        "Personointilomake",
        "height=600,width=800"
      );

      mywindow.document.write(
        "<html><head><title>Personointilomake</title><style>@page{margin:1.6cm;}*{font-family:sans-serif;}img{margin:auto;display:block;}div{page-break-inside: avoid;}</style>"
      );
      mywindow.document.write("</head><body >");
      mywindow.document.write(
        '<img src="http://aineisto.toyota.fi/library/images/logos/Toyota-logo-plain.png" />'
      );
      mywindow.document.write(content);
      mywindow.document.write("</body></html>");

      mywindow.document.close();
      mywindow.focus();
      setTimeout(() => {
        mywindow.print();
        mywindow.close();
      }, 100);
      return true;
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    // window.ga("set", "page", "/thankyou");
    // window.ga("send", "pageview");
  },
  components: {
    FormHead,
    CarHeading,
    SummaryList
  }
};
</script>

<style>
</style>
